import { useSyncExternalStore } from "react";
import { sessionStore } from "./runtime";

export function useSessionState() {
  return useSyncExternalStore(sessionStore.subscribe, sessionStore.getState);
}
